<template>
	<div>
		<!--TABELA Z KONKURSAMI PLACÓWEK-->
		<v-card-title class="mb-3">
			<h2 style="padding-left: 10px">Nabory</h2>
		</v-card-title>
		<v-dialog v-model="dialog" max-width="1000px">
			<v-btn v-if="roles.isLocalAdministrator() || roles.isAdministrator() || roles.isDepartmentEmployee()"  slot="activator" color="primary" dark
				class="ml-3 mb-1">Nowy nabór
			</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline">Nowy nabór</span>
				</v-card-title>
				<v-card-text>
					<v-form ref="form"
						v-model="newItem.valid"
						lazy-validation>
						<v-text-field name="name"
							label="Nazwa naboru"
							aria-label="full name"
							browser-autocomplete="off"
							id="agency-contest-list-name-recruitment"
							for="agency-contest-list-name-recruitment"
							v-model="newItem.name"
							:rules="validationRules"
							type="text">
						</v-text-field>
						<v-text-field name="shortName"
							label="Skrócona nazwa naboru"
							aria-label="short name"
							browser-autocomplete="off"
							id="agency-contest-list-short-name-recruitment"
							for="agency-contest-list-short-name-recruitment"
							v-model="newItem.shortName"
							:rules="validationRules"
							type="text">
						</v-text-field>
						<v-flex xs12 sm6 md4 v-if="!roles.isDepartmentEmployee() && !roles.isLocalAdministrator()">
							<v-autocomplete name="Departament" v-model="newItem.departmentId" :items="departments"
								label="Departament *"
								aria-label="department"
								id="agency-contest-list-department"
								for="agency-contest-list-department"
								item-text="name"
								item-value="id"
								data-vv-name="department"
								data-vv-as="Departament"
								:rules="validationRules"
							></v-autocomplete>
						</v-flex>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="save">
						Zapisz
					</v-btn>
					<v-btn color="blue" @click="cancel">Anuluj</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<AgencyContestDataTable ref="contestTable" v-model="dataTable"/>
	</div>
</template>

<script>

	import {Api} from "@/api";
	import AgencyContestDataTable from "./components/AgencyContestDataTable";
	import {AgencyContest} from "@/api/generated/AgencyContest";

	export default {
		name: "AgencyContestListView",
		components: {AgencyContestDataTable},

		watch: {

			dialog(val) {
				if (!val) {
					this.vErrors.clear();
				} else {
					Api.get(this, "/department/list", response => {
						this.departments = response;
					});
				}
			},
		},

		mounted () {
			this.removeEmptyTableLoading();
		},

		methods: {
			save() {
				if (!this.$refs.form.validate()) {
					return;
				}
				AgencyContest.post(this, this.newItem, () => {
						this.$messagesBus.$emit("success", "Utworzono nabór");
						this.$refs.contestTable.getItemList();
						this.dialog = false;
						this.clearDialog();
					},
					error => {
						this.$messagesBus.$emit("error", error.errors[0], error);
					});

			},

			cancel() {
				this.dialog = false;
				this.clearDialog();
			},

			clearDialog() {
				this.newItem.name = "";
				this.newItem.shortName = "";
				this.newItem.departmentId = null;
			},

			removeEmptyTableLoading () {
				var el = document.querySelector('.v-datatable__progress');
				el.parentNode.removeChild(el);
			}
		},


		data() {
			return {
				dataTable: {
					searchFields: {},
					tableHeaders: [
						{text: "", value: "termExpirationStatus", sortable: false},
						{text: "Nazwa naboru", value: "contestName", sortable: true},
						{text: "Koniec naboru wniosków", value: "endDate", sortable: true},
						{text: "Departament", value: "departmentName", sortable: true},
						{text: "Akcje", value: "action", sortable: false},
					],
					loading: false,
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
						sortBy: ''
					},
					search: "",
				},
				departments: [],
				dialog: false,

				newItem: {
					name: "",
					shortName: "",
					departmentId: null,
					valid: true,
				},
				validationRules: [
					v => !!v || "To pole jest wymagane",
				],
			};
		},
	};
</script>

<style scoped>

</style>
